var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPageAllowed)?[_c('router-view')]:[_c('NoPermissionInfo',{staticStyle:{"background-color":"#fff"}},[_c('p',[_vm._v(_vm._s(_vm.pageInfoText))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }